import React, { useState } from "react";
import './Specialization.css'
import Common_title from '../../common_components/common-title/Common_title'
import Enquiry_Form_Modal from '../../common_components/common_modal/Enquiry_Form_Modal/Enquiry_Form_Modal'

const Specialization = () => {
    const [showModal, setShowModal] = useState(false);

    const specializationData = [
        { special: 'Marketing Management' },
        { special: 'Hospital Administration and Health Care Management' },
        { special: 'Finance Management' },
        { special: 'IT Management' },
        { special: 'Human Resource Management' },
        { special: 'Operations Management' },
        { special: 'Business Analytics Management' },
        { special: 'International Business Management' },
        { special: 'FinTech Management' },
        { special: 'Digital Marketing Management' },
        { special: 'Artificial Intelligence and Machine Learning' },
        { special: 'Block Chain Management' },
        { special: 'Project Management' },
        { special: 'Logistics, Materials and Supply Chain Management' },
        { special: 'AgriBusiness Management' },
        { special: 'Master of Computer Applications' },
        { special: <>Master of Business Administration <br /> (Working Professional)</> },
    ];
    return (
        <>
            <section className='Specialization_section'>
                <div className='container-lg'>
                    <Common_title className="text-center" title='Specializations' subtitle='Choose from top Business Specializations' />

                    <div className='row mt-md-5 mt-3'>
                        {specializationData.map((item, index) => (
                            <div className='col-lg-4 col-md-4 col-6 mb-4' key={index}>
                                <div className='specialization_card' onClick={() => { setShowModal(true) }}>
                                    <p className='textname'>{item.special}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Enquiry_Form_Modal
                show={showModal}
                onHide={() => { setShowModal(false) }}
            />
        </>
    )
}

export default Specialization